export default {
    "2010": [
        {
            "date": "January 2010",
            "subject": "Inkling, etc.",
            "description": "Up until this point I had pretty much no idea of what I was going to be doing after I graduated. I know that I was going to apply to grad school, but that was mostly because I didn't know what other options were available.\n",
            "type": "email",
            "thread": [
                {
                    "from": "matt",
                    "date": "2010-01-31",
                    "body": "Hi, Andrew-\n\nI'm the founder of Inkling, a company that has just recently launched its plans for an iPad-based learning platform. We're based in San Francisco, and our website is at www.inkling.com.\n\nWe are always on the lookout for talented developers, and you've got a very interesting profile. (And you're Canadian, like me!)\n\nLooks like you are still in school, but I'm not sure whether your site is up to date. What's your status? Any interest in considering a gig in California?\n"
                },
                {
                    "from": "me",
                    "date": "2010-02-02",
                    "body": "Hey Matt,\n\nThank you for checking out my website, it's great to know that there are people out there looking at the things I love to do.\n\nMy website is relatively current, I am in my last semester of my undergraduate degree right now. As far as after graduation my options are pretty open. I have applied to do my masters at the U of A, but I won't know whether or not I am accepted until sometime in march. Even then, from what I've seen on the inkling website, I'd definitely be interested to talk more with you about a possible position. The web application engineer posting in particular piqued my interest.\n\nIf you would like, I can pass along a copy of my resume. Just let me know.\n\nThanks again. I hope to hear from you soon,\n-Andrew\n"
                },
                {
                    "from": "matt",
                    "date": "2010-02-02",
                    "body": "Andrew-\n\nYou're clearly skilled, so we'd be interested in talking to you further when the time is right.  As a startup, it's pretty tough for us to see even a few weeks out, let alone four or five months... so it's probably not fruitful to discuss things in detail at this point.\n\nHowever, when you are gearing up for your job search, can you drop me a note? Perhaps we can chat then and see if there isn't a way to consider you for a job after you graduate.\n\nThanks,\nMatt\n"
                }
            ],
            "id": "0d8452"
        },
        {
            "date": "February 2010",
            "title": "Snapshot of the Original Inkling Website",
            "images": [
                {
                    "src": "screenshots/www-2010-02-01-1.jpeg",
                    "width": 1600,
                    "height": 1740
                },
                {
                    "src": "screenshots/www-2010-02-01-2.jpeg",
                    "width": 1600,
                    "height": 1740
                },
                {
                    "src": "screenshots/www-2010-02-01-3.jpeg",
                    "width": 1600,
                    "height": 1740
                }
            ],
            "id": "060a58"
        },
        {
            "date": "March 2010",
            "type": "love",
            "title": "Meet My Future Wife",
            "id": "a4bfc7"
        },
        {
            "date": "April 2010",
            "type": "email",
            "subject": "Re: Inkling etc,",
            "description": "I actually never talked with Rob Cromwell (Founder, VP of Engineering) until after I joined. Instead I got to chat with Josh Forman (Founder, VP of Product).\n",
            "thread": [
                {
                    "from": "matt",
                    "date": "2010-04-02",
                    "body": "Ping!"
                },
                {
                    "from": "me",
                    "date": "2010-04-03",
                    "body": "Hi Matt,\n\nThat's actually quite funny, I was thinking about sending you an email sometime next week! Some big things have happened since we last talked. I've had several interviews with [company that ended up revoking their offer last minute], I was also interviewed for a position with [company that no longer exists] and lastly I have been formally accepted to begin my Masters starting in the fall.\n\nBecause of all these changes, I think that I am only looking for a 4 month summer position. I see on inkling.com  that there is a design intern position, I'm curious if something similar could exist for the a web application engineering position. Either way, I hope something can be worked out as I am definitely still interested.\n\nThank you again so much for keeping me in mind,\n-Andrew\n"
                },
                {
                    "from": "matt",
                    "date": "2010-04-02",
                    "body": "Hey-\n\nWe could certainly consider you for an internship. I am going to ask my VP of Engineering to follow up with you.\n\n-m\n"
                }
            ],
            "id": "dd3952"
        },
        {
            "date": "April 2010",
            "title": "Interview With Josh (Founder, VP of Product)",
            "id": "ae9214"
        },
        {
            "date": "April 2010",
            "title": "Interview With Matt (Founder, CEO)",
            "id": "d5ec00"
        },
        {
            "date": "April 2010",
            "title": "Interview With Scott (One of the First Front-End Engineers at Inkling)",
            "description": "I remember feeling like I did horrible on this interview, but Scott gave me the thumbs up anyway. The next day Josh sent me an offer, which I accepted pretty much immediately.",
            "id": "1fa76c"
        },
        {
            "date": "May 2010",
            "title": "Move to San Francisco",
            "description": "I actually crossed the border in Calgary and was almost denied entry since Inkling had offered me an engineering intern position, but I did not have an engineering degree (I had just finished my BS in computer science). Thankfully the border officer saw on my transcripts that I had taken a few engineering courses and begrudgingly issued me a temporary TN visa.\n\nI arrived in San Francisco late in the afternoon and took a cab straight to Inkling's 330 Townsend office.\n",
            "id": "335c0e"
        },
        {
            "date": "June 2010",
            "title": "Series A",
            "type": "funding",
            "description": "At the time Inkling was really just a temp job for me (I was supposed to go back to Canada in August to start my master's), so I can't say I had really given any thought as to where my paycheck was coming from.\n\nIn hindsight I think this was a pivotal moment for me. I remember feeling pretty excited about what we were building, but now knowing that others were willing to dump a fair amount of money on Matt et. als vision, helped validate my excitement.\n",
            "video": {
                "fileName": "matt-vs-cork-short",
                "caption": "Matt nearly losing an eye.",
                "width": 400,
                "height": 224
            },
            "id": "259930"
        },
        {
            "date": "June 2010",
            "title": "My Earliest Team Photo",
            "images": [
                {
                    "src": "pictures/2010-06-04.jpeg",
                    "caption": "**Back row:** Milan Lee, Aaron Haney, Jenson Tham, Kevin Ballard, John Wight, Scott Kyle, Rob Cromwell, Andrew Hoyer, Anne Halsall, Rob Scott (R2), Billy Tamplin, Matt MacInnis, Chatree Campiranon, Antonia Hidalgo, Lauren Struck. **Front row:** Kien Nguyen, Josh Forman, Joyce Croft, Peter Cho, Yuin Chien, Liza Brown, Nicolle Romero, Niranjan Krishnamurthi.\n",
                    "width": 1280,
                    "height": 712
                }
            ],
            "id": "0c5831"
        },
        {
            "date": "June 2010",
            "type": "happy",
            "title": "A Glimpse Into the 330 Townsend Office",
            "description": "And quite possibly the least flattering picture of me ever taken...\n",
            "images": [
                {
                    "src": "pictures/2010-06-30.jpeg",
                    "caption": "This island of desks was engineering — all seven of us, including Josh who was technically VP of Product, but helped out on the code a fair amount in those days. One of my favorite things about the old office was we had four clocks on the wall all set to Pacific Time (the labels above them were all places on the west coast).\n\nMatt sat directly behind me. As an intern, this was a very nerve wracking seating situation as I felt I had no idea what I doing back then.\n",
                    "width": 1004,
                    "height": 750
                }
            ],
            "id": "7b685c"
        },
        {
            "date": "July 2010",
            "type": "happy",
            "title": "My First Independence Day",
            "description": "Josh had a small party at his place with a bunch of folks from Inkling. I remember it was super foggy and that we couldn't see any fireworks, but we could hear them all over.\n\nLater in the evening a slightly intoxicated Scott asked me:\n\n> So... do you guys celebrate independence from whoever the fuck?\n>\n> – _Scott Kyle_\n\nI also remember Josh made a cake but accidentally put twice the amount of butter in it. It was gross.\n",
            "images": [
                {
                    "src": "pictures/2010-07-04.jpeg",
                    "caption": "The \"butter cake\" in all its glory.",
                    "width": 691,
                    "height": 449
                }
            ],
            "id": "86721e"
        },
        {
            "date": "July 2010",
            "title": "Inkling Moves to 153 Kearny Street",
            "description": "At 330 Townsend the company was actually split between two offices (one which is pictured above, and the other one up the stairs at the back of the building). When we moved into 153 Kearny, our floor was so huge that we barely took up half the floor. Also three of our five conference rooms didn't have walls so that was fun.\n",
            "images": [
                {
                    "src": "pictures/2010-12-06.jpeg",
                    "caption": "This picture is actually from around December 2010.",
                    "width": 1600,
                    "height": 326
                }
            ],
            "id": "6664e2"
        },
        {
            "date": "July 2010",
            "title": "Switch to Full-Time",
            "description": "A week or so before this Matt sat me down and outlined a little of his vision for the company and how they really wanted me to stick around. A few days later I accepted the offer no questions asked. I remember Matt smiling, saying \"We need to work on your negotiation skills.\"\n",
            "id": "71686c"
        },
        {
            "date": "August 2010",
            "title": "Inkling App 1.0 With Four Titles",
            "images": [
                {
                    "src": "pictures/2010-08-18.jpeg",
                    "caption": "Obligatory early morning clock photo.",
                    "width": 1024,
                    "height": 617
                },
                {
                    "src": "pictures/2010-08-20.jpeg",
                    "caption": "Inkling in the Wall Street Journal a few days later.",
                    "width": 540,
                    "height": 720
                }
            ],
            "id": "5ce2ea"
        },
        {
            "date": "August 2010",
            "title": "First Lunch at Z&Y",
            "video": {
                "fileName": "2010-08-28",
                "width": 568,
                "height": 320
            },
            "id": "73caff"
        },
        {
            "date": "October 2010",
            "type": "quote",
            "title": "An Accurate Description of Matt",
            "description": "> Matt opens his mouth and people throw money at him. He doesn't even have to take his clothes off.\n>\n> – _Lauren Struck_\n",
            "id": "4cefb6"
        },
        {
            "date": "December 2010",
            "title": "Extra Credit",
            "description": "Extra Credit was set up as a way to experiment with new product ideas in the form of software, content, and marketing explorations. Everyone self organized into teams of four to five people with the purpose of exploring new ideas and concepts, or just scratching an itch that had been bothering them.\n\nIt yielded quite a few cool things, the biggest being a precursor for what would eventually become Habitat. More than anything it was an amazing way to get together and work with people in the company you hadn't work with yet.\n\nFor this extra credit I worked on a prototype for a flashcard system in the iPad app. It wasn't until years later when our content supported interactive widgets (sandboxed iframes) and this feature would get built for real.\n",
            "id": "e1f05b"
        },
        {
            "date": "December 2010",
            "title": "Holiday Party!",
            "images": [
                {
                    "src": "pictures/2010-12-16.jpeg",
                    "width": 1600,
                    "height": 1200
                }
            ],
            "id": "f1b9a9"
        }
    ],
    "2011": [
        {
            "date": "January 2011",
            "title": "First Round of Waterloo Interns",
            "description": "I remember being very excited to have some more Canadians on the team.",
            "id": "ef171a"
        },
        {
            "date": "January 2011",
            "title": "Inkling Featured in the Apple Store Window Near Union Square.",
            "images": [
                {
                    "src": "pictures/2011-01-05.jpeg",
                    "width": 1600,
                    "height": 1195
                }
            ],
            "id": "cbe9d1"
        },
        {
            "date": "January 2011",
            "title": "Development of Habitat Begins",
            "images": [
                {
                    "src": "screenshots/habitat-2011-01-31.jpeg",
                    "caption": "The first screenshot of Habitat.",
                    "width": 878,
                    "height": 502
                },
                {
                    "src": "screenshots/habitat-2011-03-01.jpeg",
                    "caption": "Just a few months later (March), Brad Neuberg and others had made some pretty incredible progress.",
                    "width": 880,
                    "height": 504
                }
            ],
            "id": "36748a"
        },
        {
            "date": "March 2011",
            "type": "happy",
            "title": "Start of the First (And Only) Inkling Pool Tournament",
            "description": "The prize was a brand new iPad 2. Unfortunately the tournament didn't end before the iPad 3 came out...",
            "id": "3db3b1"
        },
        {
            "date": "April 2011",
            "title": "Nolan on Content Creation at Inkling",
            "type": "quote",
            "description": "> The first step to improvement is understanding how fucked you are.\n>\n> – _Nolan Meyers_\n",
            "id": "c2f860"
        },
        {
            "date": "April 2011",
            "title": "Inkling® and the Inkling Logotype Become Registered Trademarks of Standard Nine Inc.",
            "images": [
                {
                    "src": "screenshots/trademark.jpeg",
                    "width": 1260,
                    "height": 1600
                }
            ],
            "id": "ed5a4c"
        },
        {
            "date": "June 2011",
            "title": "Matt Presents at D9",
            "description": "[D9 Tech Demo: Inkling](http://allthingsd.com/20110602/d9-tech-demo-inkling/?refcat=d9)",
            "id": "d8860d"
        },
        {
            "date": "August 2011",
            "title": "Web Store Launch",
            "description": "This project was a nightmare, and my first real run in with burn out. Earlier in the year it was decided that if we wanted to make a real push into the text book sales market we needed to have a web version of our store (up until this point we had relied on our in-app store on the iPad).\n\nWe ended up landing everything on time, going from basically nothing to a full store in two and half months, but at the cost of my sanity. Looking back on it, I think this was one of my greatest learning experiences at Inkling. All my projects after this had much more conservative time estimates. :)\n",
            "id": "fae8d4"
        },
        {
            "date": "August 2011",
            "title": "Series B",
            "type": "funding",
            "id": "dba49e"
        },
        {
            "date": "August 2011",
            "type": "happy",
            "title": "Goodbye Lunch for Our First Infra Intern",
            "video": {
                "fileName": "2011-08-26",
                "width": 480,
                "height": 360
            },
            "id": "7c0d44"
        },
        {
            "date": "September 2011",
            "title": "Brad and Ivan, Being Brad and Ivan",
            "video": {
                "fileName": "2011-09-01",
                "width": 400,
                "height": 224
            },
            "id": "a52de7"
        },
        {
            "date": "September 2011",
            "title": "Development of Inkling for Web Begins",
            "description": "This is the earliest screenshot of Inkling for Web I could find. The geocities-esque under construction gifs were a nice touch.",
            "images": [
                {
                    "src": "screenshots/web-client-2011-09-30.jpeg",
                    "width": 881,
                    "height": 459
                }
            ],
            "id": "5311f6"
        },
        {
            "date": "November 2011",
            "title": "\"Fully Functional\"",
            "description": "Just a couple months later we had a reasonably fully functional (and fully unit tested) web reader that also supported user highlights. However this was all built using a very hacky local API, hence the broken looking content.",
            "images": [
                {
                    "src": "screenshots/web-client-2011-11-01.jpeg",
                    "caption": "At one point the horrible dev styling by Brad Vogel was driving me crazy so I styled everything to look like the wireframes we were working from at the time.",
                    "width": 878,
                    "height": 507
                }
            ],
            "id": "2e81f5"
        },
        {
            "date": "December 2011",
            "type": "happy",
            "title": "Brad Vogel Reading to the Web Team",
            "images": [
                {
                    "src": "pictures/2011-12-02.jpeg",
                    "caption": "He was reading a computer science textbook from the 1950's.",
                    "width": 800,
                    "height": 598
                }
            ],
            "id": "30dbe9"
        },
        {
            "date": "December 2011",
            "title": "Some Polish on Inkling for Web",
            "description": "By the end of the year Design was starting to hand us a first round of visual mocks so I of course jumped on the chance to make things a little prettier.",
            "images": [
                {
                    "src": "screenshots/web-client-2011-12-30.jpeg",
                    "width": 881,
                    "height": 505
                }
            ],
            "id": "a5a3e9"
        },
        {
            "date": "December 2011",
            "title": "Holiday Party!",
            "id": "0572dc"
        }
    ],
    "2012": [
        {
            "date": "January 2012",
            "title": "100 Books on Inkling",
            "images": [
                {
                    "src": "pictures/2011-12-23.jpeg",
                    "caption": "At our 153 Kearny office the content team kept tabs of our progress.",
                    "width": 1600,
                    "height": 538
                }
            ],
            "id": "551c21"
        },
        {
            "date": "February 2012",
            "type": "sad",
            "title": "Spontaneous Collapsed Lung 1.0",
            "description": "Or, how to get 3 weeks paid vacation.",
            "id": "f9f3f1"
        },
        {
            "date": "February 2012",
            "title": "Matt Announces Habitat at O'Reilly Tools of Change",
            "description": "This is where Matt announced a private beta of Inkling Habitat.",
            "youtube": "https://www.youtube.com/embed/z5bborgjHF4?rel=0",
            "id": "f62a07"
        },
        {
            "date": "March 2012",
            "type": "happy",
            "title": "Content Team's Portrait Pillar",
            "description": "Occasionally some people on the content team would draw portraits of folks at Inkling.",
            "images": [
                {
                    "src": "pictures/2012-03-15 1.jpeg",
                    "width": 800,
                    "height": 1067
                },
                {
                    "src": "pictures/2012-03-15 2.jpeg",
                    "caption": "I'm not sure they captured my likeness...",
                    "width": 800,
                    "height": 1067
                }
            ],
            "id": "955797"
        },
        {
            "date": "March 2012",
            "type": "happy",
            "title": "Fancy Friday: Tuxedo Shirt Edition",
            "images": [
                {
                    "src": "pictures/2012-03-23.jpeg",
                    "width": 873,
                    "height": 701
                }
            ],
            "id": "4095d0"
        },
        {
            "date": "April 2012",
            "type": "happy",
            "title": "Life Cycle of Giardia",
            "description": "One of the best parts of Inkling's early days was having the chance to explore the amazing medical content on the platform.",
            "images": [
                {
                    "src": "pictures/2012-04-17.jpeg",
                    "width": 768,
                    "height": 1024
                }
            ],
            "id": "a056c8"
        },
        {
            "date": "May 2012",
            "title": "Extra Credit 2012",
            "description": "Just like the first Extra Credit in 2010, there were some pretty cool and useful projects such as a live analytics feed of customers interacting with our books and store. Unlike the first Extra Credit, there were a couple projects that used things like arduino, LEDs, and piezo speakers, to essentially just make noise and flash lights. It was all in good fun though.\n\nUnfortunately I didn't get to a chance to participate since me and a few other people had our heads down on completing Inkling for Web.\n",
            "id": "338733"
        },
        {
            "date": "May 2012",
            "title": "Inkling for Web 1.0",
            "images": [
                {
                    "src": "pictures/2012-05-30.jpeg",
                    "caption": "Obligatory early morning clock photo.",
                    "width": 1600,
                    "height": 887
                },
                {
                    "src": "screenshots/web-client-2012-05-30.jpeg",
                    "caption": "Snapshot of Inkling for Web at launch.",
                    "width": 882,
                    "height": 506
                }
            ],
            "id": "3cb4ae"
        },
        {
            "date": "June 2012",
            "type": "happy",
            "title": "First Game of Diplomacy Happens in the Office",
            "description": "Diplomacy is often quoted as being \"the game that destroys friendships\". Thankfully it proved to be a quasi-team building exercise... where Ned Rockson and I conquered Europe.",
            "images": [
                {
                    "src": "pictures/2012-07-04.jpeg",
                    "width": 800,
                    "height": 801
                }
            ],
            "id": "81ad3c"
        },
        {
            "date": "July 2012",
            "title": "Inkling Goes to the Giants Game",
            "images": [
                {
                    "src": "pictures/2012-07-27.jpeg",
                    "width": 960,
                    "height": 460
                }
            ],
            "id": "ea276e"
        },
        {
            "date": "September 2012",
            "title": "Inkling Expands to Two Floors at 153 Kearny",
            "description": "Before this we were all packed on one floor. If one person got sick, we all got sick.",
            "id": "7d9703"
        },
        {
            "date": "September 2012",
            "type": "happy",
            "title": "Full Company Fancy Friday",
            "images": [
                {
                    "src": "pictures/2012-09-13-1.jpeg",
                    "width": 1600,
                    "height": 1063
                },
                {
                    "src": "pictures/2012-09-13-2.jpeg",
                    "caption": "Fancy Friday was started by Kenn Knowles (on the far left) as a fun jab at the fact that everyone dressed casual every other day of the week. The best part of this picture is Lere and myself doing our best GQ model poses.",
                    "width": 1600,
                    "height": 1063
                }
            ],
            "id": "33f21c"
        },
        {
            "date": "October 2012",
            "title": "Open Inkling Launch",
            "description": "One thing that became apparent after the launch of Inkling for Web was that user's didn't want to create an account just to preview content. So after a summer of bringing Inkling for Web up to parity with the iPad app we turned our attention towards creating a version where a users could browse a few pages before being asked to sign up. A nice side effect of Open Inkling was we could now let Google index our content.",
            "images": [
                {
                    "src": "screenshots/web-client-2012-11-18.jpeg",
                    "width": 880,
                    "height": 505
                }
            ],
            "id": "44f04e"
        },
        {
            "date": "October 2012",
            "title": "Web Team Offsite to Tiburon",
            "images": [
                {
                    "src": "pictures/2012-10-19.jpeg",
                    "width": 960,
                    "height": 717
                }
            ],
            "id": "d3693c"
        },
        {
            "date": "October 2012",
            "title": "Collapsed Lung 2.0",
            "type": "sad",
            "description": "My lung collapsed a second time. But it was during my month off to recover that I actually came up with the idea that would eventually become inkling's internal build tracking system (called Air Traffic Control, or ATC for short).",
            "images": [
                {
                    "src": "pictures/2012-11-02.jpeg",
                    "caption": "Best get well card message from Eric Lovett.",
                    "width": 1389,
                    "height": 1000
                }
            ],
            "id": "f67a7f"
        },
        {
            "date": "December 2012",
            "title": "Holiday Party!",
            "id": "20be27"
        }
    ],
    "2013": [
        {
            "date": "February 2013",
            "title": "Mobile Open Inkling",
            "images": [
                {
                    "src": "screenshots/web-client-2013-01-10.jpeg",
                    "caption": "Dat simulator.",
                    "width": 782,
                    "height": 744
                }
            ],
            "id": "12ffba"
        },
        {
            "date": "February 2013",
            "title": "Unbound: Public Launch of Inkling Habitat",
            "images": [
                {
                    "src": "pictures/2013-02-11-1.jpeg",
                    "width": 1600,
                    "height": 1067
                },
                {
                    "src": "pictures/2013-02-11-2.jpeg",
                    "width": 1600,
                    "height": 1067
                }
            ],
            "id": "34494d"
        },
        {
            "date": "March 2013",
            "type": "happy",
            "title": "Onesie Wednesday",
            "images": [
                {
                    "src": "pictures/2013-03-20.jpeg",
                    "width": 960,
                    "height": 527
                }
            ],
            "id": "7a8653"
        },
        {
            "date": "April 2013",
            "title": "Air Traffic Control 1.0",
            "description": "This was an incredibly satisfying project to work on since it improved the lives of everyone on engineering. At the time of writing this (four years later), it is still an integral part of the development cycle for many of Inkling's products.\n\nBecause this was an internal project, things were a little fast and loose in terms of code reviews. This meant that one member of our team (who shall remain nameless), got to truly express himself via his commit messages...\n",
            "type": "aashayCommits",
            "id": "f962f4"
        },
        {
            "date": "May 2013",
            "title": "Extra Credit 2013",
            "description": "To help keep things a little more focused, this Extra Credit had some rules, the most important being:\n\n> Your project must have an obvious benefit to users, to the platform, or to the company.\n\nI worked on a prototype for a content analytics dashboard. We ended up building a subset of this for real in 2014.\n",
            "images": [
                {
                    "src": "screenshots/extra-credit-2013-05-03.jpeg",
                    "width": 871,
                    "height": 947
                }
            ],
            "id": "1da8bc"
        },
        {
            "date": "May 2013",
            "title": "Inkling's First Ping Pong Tournament",
            "images": [
                {
                    "src": "pictures/2013-05-13.jpeg",
                    "width": 1600,
                    "height": 1200
                }
            ],
            "id": "3ffa69"
        },
        {
            "date": "May 2013",
            "title": "Growth Team Starts",
            "description": "The Growth Team was formed to see if we could start making changes to our platform (in particular the web experience) to improve growth (in particular sales, and new user sign ups).\n\nBelow is the first experiment we ever ran:\n",
            "images": [
                {
                    "src": "screenshots/web-client-2013-05-25-0.jpeg",
                    "caption": "The control variation with the call to action sidebar on the right.",
                    "width": 1100,
                    "height": 941
                },
                {
                    "src": "screenshots/web-client-2013-05-25-2.jpeg",
                    "caption": "Variation with the sidebar moved to the bottom.",
                    "width": 1100,
                    "height": 941
                },
                {
                    "src": "screenshots/web-client-2013-05-25-1.jpeg",
                    "caption": "Variation with the sidebar on the left. This variation ended up winning as it improved the signup click through by almost 10%.",
                    "width": 1100,
                    "height": 941
                }
            ],
            "id": "9d95a8"
        },
        {
            "date": "June 2013",
            "type": "happy",
            "title": "???",
            "video": {
                "fileName": "2013-06-18",
                "width": 400,
                "height": 400
            },
            "id": "6c082b"
        },
        {
            "date": "July 2013",
            "title": "Series C",
            "type": "funding",
            "id": "341855"
        },
        {
            "date": "July 2013",
            "type": "happy",
            "title": "The Time Someone in the Birst Office Left a Cup of Noodle in the Microwave a Little Too Long",
            "video": {
                "fileName": "2013-07-30",
                "width": 400,
                "height": 224
            },
            "id": "5fc261"
        },
        {
            "date": "September 2013",
            "title": "Inkling's 4th Anniversary Party",
            "images": [
                {
                    "src": "pictures/2013-09-27.jpeg",
                    "width": 1600,
                    "height": 401
                }
            ],
            "description": null,
            "id": "fc70a7"
        },
        {
            "date": "November 2013",
            "title": "A Snapshot of the Growth Team's Progress",
            "description": "By the end of the year we had made some pretty significant improvements to the sign up and store conversion flows, as well as just tightening up the style on Open Inkling for Web.\n\nThe cloud side of the Growth Team also rewrote our entire analytics pipeline to handle the growing scale of the platform as well.\n",
            "images": [
                {
                    "src": "screenshots/web-client-2013-11-19.jpeg",
                    "width": 1600,
                    "height": 1015
                }
            ],
            "id": "feccff"
        },
        {
            "date": "December 2013",
            "title": "Holiday Party!",
            "images": [
                {
                    "src": "screenshots/2013-holiday-party.jpeg",
                    "width": 1368,
                    "height": 1428
                }
            ],
            "id": "d84b41"
        }
    ],
    "2014": [
        {
            "date": "February 2014",
            "type": "sad",
            "title": "End of the Growth Team",
            "description": "Over the course of about 10 months we ran over 20 experiments of varying complexity.\n\nHowever, around this time was when we disbanded the Growth Team since, while we did make some great steps forward, we weren't making enough progress. From the Growth Team I ended up switching over to work on Habitat.\n",
            "images": [
                {
                    "src": "screenshots/web-client-2013-12-16.jpeg",
                    "caption": "One of the last experiments we ran was to show related content to users. I was, and still am, particularly proud of this experiment since at the time it was a ton of fun to hack together.",
                    "width": 1311,
                    "height": 763
                }
            ],
            "id": "56a314"
        },
        {
            "date": "April 2014",
            "type": "happy",
            "title": "Habitat Team Lunch",
            "video": {
                "fileName": "2014-04-11",
                "width": 640,
                "height": 360
            },
            "id": "e0c09f"
        },
        {
            "date": "May 2014",
            "title": "Layoffs and Pivot",
            "type": "sad",
            "description": "This was hard.\n\nI remember seeing an email from Matt the day before asking everyone to come in by 10:45am the next day. Everyone was somewhat excited since the email was vague and mysterious. Half the company was asked to meet down on the 4th floor where Matt told them they had been let go, while the other half stayed on the 5th where Rob let us know what going on.\n\nIt was super difficult seeing so many people that I'd worked with since the early days leave. The next few months were pretty rough too as people trickled out on their own. Eventually though, we got our footing again and things started to improve. Looking back, I'm glad I stuck it out.\n",
            "id": "315f46"
        },
        {
            "date": "May 2014",
            "title": "Got Engaged",
            "type": "love",
            "id": "408497"
        },
        {
            "date": "May 2014",
            "title": "Engineering Offsite",
            "images": [
                {
                    "src": "pictures/2014-05-23.jpeg",
                    "caption": "Inkling rented a small movie theater so we could play video games on the big screen and board games out in the lobby.",
                    "width": 1600,
                    "height": 1068
                }
            ],
            "id": "ca77e5"
        },
        {
            "date": "August 2014",
            "title": "Inc. 500",
            "description": "Inkling was included at #105 on [Inc. Magazine's Inc. 500 list of the Fastest Growing Private Companies in America](https://www.inc.com/profile/inkling).\n\nWe were also the #3 Fastest Growing Company in San Francisco, #6 Fastest Growing Company in Silicon Valley, #8 Fastest Growing Company in software, #18 Fastest Growing Company in California.\n",
            "id": "5404a3"
        },
        {
            "date": "September 2014",
            "type": "happy",
            "title": "First Ever Boba Fête",
            "description": "By 2014, I decided that I had been drinking too much boba. So I ended up taking a break for a month. At the end, Andy Perelson organized a Boba Fête where a group of 10 or so Inkblots went out and got boba together. From the calendar invite:\n\n> Hoyer has fasted for a whole month, giving up boba tea. Now he is rejoining the ranks of Inkling boba drinkers, and we will celebrate with a gluttonous trip to get boba aplentea. Come to Inkling's first ever Boba Fête.\n>\n> Already back from Burning Man? Rehydrate with boba tea!\n>\n> Always too busy for boba? Now you have advanced notice to clear your calendar and make time for this important team event.\n>\n> Don't drink boba? Get something else. Come and discuss this weird custom of eating large balls of tapioca out of a straw with your coworkers. Who comes up with this stuff?!?\n>\n> Small Print: This is in no way a celebration or endorsement of Boba Fett\n",
            "id": "7bba9d"
        },
        {
            "date": "September 2014",
            "type": "happy",
            "title": "Boba Guys Union Square Location Opens",
            "description": "Boba Guys just a few blocks away from both work and home proved to be a net negative on my waistline...",
            "id": "546749"
        },
        {
            "date": "October 2014",
            "title": "Founding of the Boba Guild",
            "type": "happy",
            "description": "During a demo at an Engineering all hands meeting, I was showing off a new right click menu that could be used to quickly add pages to Habitat projects. I happened to be demoing from our engineering Habitat project which outlined our squads and guilds (At the time Inkling was following [spotify's organzizational model](https://labs.spotify.com/2014/03/27/spotify-engineering-culture-part-1/)), so I jokingly added the boba guild. Shortly after the meeting I set up the hipchat room (pre-slack days).\n",
            "id": "6e5b63"
        },
        {
            "date": "December 2014",
            "title": "Race Track Complete",
            "images": [
                {
                    "src": "pictures/2014-12-14.jpeg",
                    "caption": "After the pivot in 2014 Engineering turned its attention towards fleshing out a full end to end flow for content on the Inkling platform, meaning authors could easily create content, distribute it, have users read it, and then allow the authors to view analytics on how well their content is being received. Internally this was called the race track.\n\nBelow is a screenshot of the beta analytics dashboard a couple other Inkblots and I churned out in just a couple months.\n",
                    "width": 1600,
                    "height": 660
                },
                {
                    "src": "screenshots/habitat-2014-11-10.jpeg",
                    "width": 1600,
                    "height": 1105
                }
            ],
            "id": "8c53c7"
        },
        {
            "date": "December 2014",
            "title": "Holiday Party!",
            "images": [
                {
                    "src": "pictures/2014-12-04.jpeg",
                    "width": 960,
                    "height": 720
                }
            ],
            "id": "f81970"
        }
    ],
    "2015": [
        {
            "date": "March 2015",
            "title": "Engineering Offsite at Hands on Gourmet",
            "images": [
                {
                    "src": "pictures/2015-03-27.jpeg",
                    "width": 960,
                    "height": 509
                }
            ],
            "id": "be1f59"
        },
        {
            "date": "April 2015",
            "title": "Extra Credit 2015",
            "description": "For this extra credit I worked with a few folks to create an interface for understanding the relationships between different parts of our Analytics infrastructure.",
            "images": [
                {
                    "src": "screenshots/extra-credit-2015-04-04.jpeg",
                    "width": 1600,
                    "height": 774
                }
            ],
            "id": "7600fb"
        },
        {
            "date": "May 2015",
            "title": "Series D",
            "type": "funding",
            "id": "a3783a"
        },
        {
            "date": "May 2015",
            "title": "I Get Married",
            "type": "love",
            "images": [
                {
                    "src": "pictures/2015-05-23.jpeg",
                    "width": 1600,
                    "height": 996
                }
            ],
            "id": "49a61a"
        },
        {
            "date": "August 2015",
            "title": "Inc. 500",
            "description": "Inkling was included at #417 on [Inc. Magazine's Inc. 500 list of the Fastest Growing Private Companies in America](https://www.inc.com/profile/inkling).\n",
            "id": "a97c16"
        },
        {
            "date": "September 2015",
            "title": "Reporting Dashboard 2.0",
            "description": "Following the successful reception of the beta analytics dashboard we built in late 2014, we spent the first half of 2015 building out a more robust and full-featured version that we could easily roll out to all our customers.",
            "images": [
                {
                    "src": "screenshots/habitat-2015-09-01-1.jpeg",
                    "width": 1191,
                    "height": 704
                },
                {
                    "src": "screenshots/habitat-2015-09-01-2.jpeg",
                    "width": 1199,
                    "height": 675
                },
                {
                    "src": "screenshots/habitat-2015-09-01-3.jpeg",
                    "width": 1186,
                    "height": 952
                }
            ],
            "id": "3925ff"
        },
        {
            "date": "October 2015",
            "title": "I Move to Brooklyn",
            "type": "love",
            "id": "c16f2e"
        },
        {
            "date": "November 2015",
            "title": "Habitat Team Offsite in Santa Cruz",
            "description": "It was at this offsite that I got to build out live content snippet previews.",
            "images": [
                {
                    "src": "screenshots/habitat-2015-11-11.gif",
                    "width": 627,
                    "height": 372
                }
            ],
            "id": "3579fc"
        },
        {
            "date": "December 2015",
            "title": "Holiday Party!",
            "description": "Also the year that we were all given Matt Bucks (I think they were actually called Inkbits) which we got to allot to different charities.\n",
            "images": [
                {
                    "src": "pictures/matt-bucks.jpeg",
                    "caption": "Sadly, Matt Bucks could not be exchanged for [Stanley Nickels](http://theoffice.wikia.com/wiki/Stanley_Nickel).",
                    "width": 1024,
                    "height": 754
                }
            ],
            "id": "31e831"
        }
    ],
    "2016": [
        {
            "date": "February 2016",
            "type": "happy",
            "title": "Boba Fête - Episode II - RETURN OF THE BOBA GUILD",
            "description": "From the calendar invite:\n\n> A long time ago, in a galaxy [not so] far far away...\n>\n> EPISODE II\n>\n> RETURN OF THE BOBA GUILD\n>\n> It is a dark time for the Boba Guild. Although there is more boba in the area than ever before, priorities have shifted towards getting work done instead of enjoying delicious sugary drinks and fresh air with each other.\n>\n> Returning from the remote ice world of New York, a young (is 28 still young?) engineer has come back to lead the Boba Guild on a Boba pilgrimage and thus restore balance to the guild member's priorities.\n>\n> Our last Boba Fête was way back in September 2014. It's about time we get a group of boba lovers together and head on over to Boba Guys (and get a little fresh air on the way).\n>\n> This is an open invite so feel free to add anyone that shows the slightest amount of interest. The more the merrier!\n",
            "id": "15ef55"
        },
        {
            "date": "May 2016",
            "title": "Birth of the Multi-Emoji",
            "multiDescription": "Someone at Inkling (either Jackson Hoose or Greg Wahnon) came up with the idea of combining multiple slack emojis to create a single large emoji. I may have taken this too far and built a set of scripts for splitting gifs, then added a custom handler in our slack bot so that I wouldn't have to type them out.\n\n**Note: If the tiled gifs load out of sync just refresh the page.**\n",
            "singleDescription": "I'm also quite proud of some of the regular emoji I added over the years.\n",
            "type": "emoji",
            "id": "8a67cd"
        },
        {
            "date": "June 2016",
            "title": "People, Pies & Blue Skies -  2016 Company Picnic",
            "images": [
                {
                    "src": "pictures/2016-06-10-company.jpeg",
                    "width": 1600,
                    "height": 747
                }
            ],
            "id": "c1d651"
        },
        {
            "date": "July 2016",
            "type": "happy",
            "title": "Cleaning Up Habitat's Color Palette Begins",
            "description": "Over a couple months I consolidated colors used in Habitat's CSS from 374 down to 108. I also set up a system for naming and viewing all the colors so that we hopefully wouldn't end up in a similar mess.",
            "images": [
                {
                    "src": "screenshots/habitat-2016-09-28.jpeg",
                    "width": 1600,
                    "height": 1129
                }
            ],
            "id": "e90af5"
        },
        {
            "date": "September 2016",
            "title": "Delight Improvements",
            "description": "Throughout 2016 I was given the opportunity to design and build a lot of \"delight improvements\" all over Habitat. Things like:\n\n* Standardizing our modal styles.\n* Adding modal transitions.\n* Improving table creation.\n* Consolidating our colors (seen above).\n\nBelow you can see a few nice transitions (a little choppy because it's a gif) that I added to the project creation flow in Habitat:\n",
            "images": [
                {
                    "src": "screenshots/habitat-2016-09-20.gif",
                    "width": 1356,
                    "height": 790
                }
            ],
            "id": "ef0b53"
        },
        {
            "date": "November 2016",
            "title": "Initial research and discover on Inkling field communication project begins",
            "description": "A team 6 or 7 of us were assembeld to begin buildng a prototype for the NRF big show that Inkling would be attending in January 2017.\n",
            "id": "0fde20"
        },
        {
            "date": "December 2016",
            "title": "Habitat Team Offsite",
            "images": [
                {
                    "src": "pictures/2016-12-09-1.jpeg",
                    "width": 1600,
                    "height": 1200
                },
                {
                    "src": "pictures/2016-12-09-2.jpeg",
                    "caption": "Twinsies!",
                    "width": 768,
                    "height": 625
                }
            ],
            "id": "26095f"
        },
        {
            "date": "December 2016",
            "title": "Series E",
            "type": "funding",
            "id": "206e30"
        },
        {
            "date": "December 2016",
            "title": "Holiday Party!",
            "images": [
                {
                    "src": "pictures/2016-12-15.jpeg",
                    "width": 1600,
                    "height": 1068
                }
            ],
            "id": "65bb63"
        }
    ],
    "2017": [
        {
            "date": "January 2017",
            "title": "Inlking Demos a new Field Communications Prototype at The Big Show",
            "description": "In Decemeber 2016 a few people (including myself) were assigned to a team to build out a prototype product that would eventually become know as Inkling Workflow.\n\nOverall the new prototype was very well recieved. So well so that a few months later we temporarily halted development on the our existing products (Habitat, Inkling for Web, iOS/Android apps) so that the whole engineering and design team could focus on building out Inkling Workflow by October.\n",
            "images": [
                {
                    "src": "screenshots/nrf-2016-12-14.gif",
                    "caption": "Above is a screen capture of the web half of the demo. Users could create a notice (notificiation) that could then be published to any number of iOS devices.",
                    "width": 865,
                    "height": 680
                }
            ],
            "id": "534936"
        },
        {
            "date": "January 2017",
            "title": "Personal Branding",
            "description": "All of the remote employees at Inkling have cardboard cutouts of themselves to leave on their desks in the office. I was super happy find out that Harper let me maintain my [personal brand](https://twitter.com/ndrwhr) 😅.",
            "images": [
                {
                    "src": "pictures/2017-01-18.jpeg",
                    "caption": "Apparently the printing company called multiple times to make sure they were printing the right file.",
                    "width": 768,
                    "height": 576
                }
            ],
            "id": "a3715a"
        },
        {
            "date": "March 2017",
            "title": "Andrew Wang-Hoyer: Designer",
            "description": "When the decision was made that we were going to build the Inkling Workflow product for real we found out that our Design Team was a little understaffed, so Inkling gave me the opportunity to put on my designer hat for a couple weeks and try to come up with some mocks that the team could start working on as soon as possible.\n",
            "images": [
                {
                    "src": "screenshots/workflow-2017-03-10.jpeg",
                    "caption": "This is an export from one of my sketch files. It was a lot of fun making this, but I found that after a few weeks of sketch made me miss actually building and prototyping things in code.",
                    "width": 1600,
                    "height": 1067
                }
            ],
            "id": "395cbc"
        },
        {
            "date": "May 2017",
            "type": "love",
            "title": "I'm a Permanent Resident",
            "id": "7c350c"
        },
        {
            "date": "June 2017",
            "title": "Inkling Workflow Beta 1",
            "images": [
                {
                    "src": "screenshots/workflow-2017-05-25.jpeg",
                    "caption": "For beta 1 it was decided we should treat the notices dashboard as a separate product, so we removed all of the habitat specific styling. This is a screenshot from the actual dashboard that the team and I built in just a couple months after I finished my design sprint.",
                    "width": 1600,
                    "height": 885
                }
            ],
            "id": "256df3"
        },
        {
            "date": "September 2017",
            "title": "Inkling Workflow Beta 2",
            "description": "This was my last major project at Inkling and by far one of the most satisfying things I ever worked on. For this project I got to work as the DRI (directly responsible individual) for the admin side of the Workflow product. It was a lot of work, but also a lot of fun.\n",
            "images": [
                {
                    "src": "screenshots/workflow-2017-08-29.jpeg",
                    "width": 1189,
                    "height": 937
                }
            ],
            "id": "887ad5"
        },
        {
            "date": "September 2017",
            "type": "happy",
            "title": "Going Away Dinner",
            "video": {
                "fileName": "2017-09-28",
                "width": 640,
                "height": 360
            },
            "id": "b8af35"
        },
        {
            "date": "September 2017",
            "title": "Last Day at Inkling",
            "images": [
                {
                    "src": "pictures/2017-09-29-1.jpeg",
                    "caption": "My last day at Inkling happened to coincide with a team offsite to lucky strike.",
                    "width": 1600,
                    "height": 908
                },
                {
                    "src": "pictures/2017-09-29-2.jpeg",
                    "width": 1600,
                    "height": 1055
                },
                {
                    "src": "pictures/2017-09-29-3.jpeg",
                    "width": 1600,
                    "height": 939
                }
            ],
            "id": "9cfb8e"
        }
    ]
};



// WEBPACK FOOTER //
// ./src/data/milestones.js